import { selectorFamily, atom } from 'recoil';
import { AgreementsService } from 'api';
import flatArray from 'utils/general/flatArray';
import isObeActive from 'utils/obes/isObeActive';
export const getCustomerVehiclesRequestIdState = atom({
  key: 'getCustomerVehiclesRequestIdState',
  default: 0
});
const getCustomerVehicles = selectorFamily({
  key: 'getCustomerVehicles',
  get: customerId => async ({
    get
  }) => {
    let vehicles = [];
    get(getCustomerVehiclesRequestIdState);
    if (!customerId) return vehicles;
    try {
      const agreementsAndVehicles = await AgreementsService.getAgreementsWithObEsAndVehiclesForCustomer({
        customerId,
        body: {}
      });
      if (agreementsAndVehicles.results) {
        vehicles = agreementsAndVehicles.results.filter(content => content.obes).map(content => content.obes?.map(obe => ({
          obeId: obe.obeId,
          obeNumber: obe.obeNumber,
          obeStatus: obe.obeStatus,
          agreementName: content.name,
          ...obe.vehicle
        })).filter(vehicle => vehicle.registrationNumber).filter(obe => isObeActive(obe.obeStatus))).reduce((arr, element) => arr?.concat(Array.isArray(element) ? flatArray(element) : element), []);
        return vehicles;
      }
    } catch (e) {
      return undefined;
    }
    return vehicles;
  }
});
export default getCustomerVehicles;